import { render, staticRenderFns } from "./SitesAdd.vue?vue&type=template&id=a0b6883c&scoped=true"
import script from "./SitesAdd.vue?vue&type=script&lang=ts"
export * from "./SitesAdd.vue?vue&type=script&lang=ts"
import style0 from "./SitesAdd.vue?vue&type=style&index=0&id=a0b6883c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b6883c",
  null
  
)

export default component.exports